<template>
  <div class="page-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <!-- 主办方联系方式卡片 -->
        <div class="page-card">
          <!-- 页头 -->
          <div class="page-card__header">
            <el-row>
              <el-col :span="4"> 主办方联系方式</el-col>
              <el-col :span="20" style="text-align: right">
                <el-button round size="small" @click="updateContent">修改</el-button>
              </el-col>
            </el-row>
          </div>

          <!-- 内容展示 -->
          <div class="page-card__body" v-if="updateShow" style="text-align: left; min-height: 500px">
            <div style="font-size: 14px; line-height: 30px">
              <pre>{{ sponsor }}</pre>
              <pre>{{ contact }}</pre>
            </div>
          </div>

          <!-- 表单编辑 -->
          <div class="page-card__body" v-else>
            <div style="text-align: left; padding: 20px 0">主办方名称</div>
            <el-input type="text" v-model="sponsor"></el-input>
            <div style="text-align: left; padding: 20px 0">填写联系方式：</div>
            <el-input type="textarea" v-model="contact" :rows="10"></el-input>
            <div style="padding: 20px 0">
              <el-button type="primary" round @click="submitClick">确认修改</el-button>
              <el-button type="danger" round @click="updateContent">取消修改</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "eventContact",
  data() {
    return {
      updateShow: true,
      sponsor: "",
      contact: "",
      config_id: localStorage.getItem('config_id')
    };
  },
  mounted() {
    // 获取主办方联系方式
    this.getInfo();
  },
  methods: {
    // 获取主办方联系方式
    getInfo() {
      let url = this.baseUrl + "/admin/config/";
      api.fetchData(url).then((res) => {
        this.contact = res[0].contact;
        this.sponsor = res[0].sponsor;
      });
    },

    // 切换编辑/展示状态
    updateContent() {
      this.updateShow = this.updateShow === true ? false : true;
    },

    // 提交修改联系方式
    submitClick() {
      if (this.textarea === "") {
        this.$message({
          message: "主办方联系方式不能为空",
          type: "warning",
        });
      } else {
        let url = this.baseUrl + "/admin/config/" + this.config_id + "/";
        api.patchData(url, {
          contact: this.contact,
          sponsor: this.sponsor,
        }).then((res) => {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.updateContent();
        });
      }
    },
  },
  components: {
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/eventContact.vue